// Copyright 2026 Bitech.id. Licensed under the MIT License.

/**
 * Gzips a JSON-serializable value via the native CompressionStream API
 * (available in all modern target browsers). Falls back to uncompressed
 * bytes only if CompressionStream isn't available — callers must still
 * enforce max_chunk_bytes against the returned size either way.
 */
export async function gzipJson(value: unknown): Promise<ArrayBuffer> {
  const bytes = new TextEncoder().encode(JSON.stringify(value));

  if (typeof CompressionStream === 'undefined') {
    // .slice() copies into a plain, non-generic ArrayBuffer.
    return bytes.buffer.slice(bytes.byteOffset, bytes.byteOffset + bytes.byteLength);
  }

  const stream = new CompressionStream('gzip');
  const writer = stream.writable.getWriter();
  void writer.write(bytes);
  void writer.close();

  return new Response(stream.readable).arrayBuffer();
}
